module.exports = BMap;


//////////////////
// WEBPACK FOOTER
// external "BMap"
// module id = 56
// module chunks = 2